import React from 'react';
import { Segment, Form, Button, Table, Loader, Popup, Icon, Input, Header } from 'semantic-ui-react';
import axios from 'axios';
import { Redirect } from 'react-router';
import { ToastContainer, toast } from 'react-toastify';
import { fetchStudyType, fetchStudentStatuses } from '../../Lookups/util';
import { FiltersOnStyle, HeaderCursor, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import request from '../../util/request';

// for all roles
// todo: move file to util directory
export default class StudentOverviewFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: '',
            lastName: '',
            index: '',
            jmbg: '',

            student: null,

            studentStatuses: [],
            studyTypes: [],
            filterData: [],
            filterDataOrgUnit: [],
            orgUnits: [],
            orgUnit: null,

            loading: false,
            showStudentInfo: false

        };

        this.showStudent = this.showStudent.bind(this);
        this.getStudentsForAdmin = this.getStudentsForAdmin.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getStudents = this.getStudents.bind(this);
        this.filterWithRememberedValues = this.filterWithRememberedValues.bind(this);
        this.resetFilters = this.resetFilters.bind(this);
    }

    componentDidMount() {
        request.fetchOrgUnits()
            .then(orgUnits => this.setState({ orgUnits }));
        let activeRole = localStorage.getItem('activeRole');
        // window.localStorage.clear();

        localStorage.setItem('activeRole', activeRole);
        this.filterWithRememberedValues();
        axios.all([fetchStudyType(), fetchStudentStatuses()])
            .then(axios.spread((typesRes, statusesRes) => {
                const studyTypes = typesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.displayName
                }));
                let studentStatuses = statusesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));

                if (localStorage.getItem('activeRole').substr(0, 41) !== 'Studentska: Akademija scenskih umjetnosti') {
                    studentStatuses = studentStatuses.filter(el => el._key !== 'gap_year');
                }
                this.setState({
                    studentStatuses, studyTypes
                });
            }))
            .catch(err => {
                console.log('Failed to fetch study types or student statuses');
            });
    }
    resetFilters() {
        localStorage.removeItem('orgUnit');
        localStorage.removeItem('firstName');
        localStorage.removeItem('lastName');
        localStorage.removeItem('index');
        localStorage.removeItem('jmbg');
        this.setState({
            firstName: '', lastName: '', index: '', jmbg: '', orgUnit: null, filterData: [], filterDataOrgUnit: [], loading: false
        });
    }
    filterWithRememberedValues() {
        const firstName = localStorage.getItem('firstName');
        const lastName = localStorage.getItem('lastName');
        const index = localStorage.getItem('index');
        const jmbg = localStorage.getItem('jmbg');
        const orgUnit = localStorage.getItem('orgUnit');

        if (!firstName && !lastName && !index && !jmbg) {
            // toast('Morate unijeti bar jedan filter.');
            return;
        }
        if (!orgUnit && (!firstName || !lastName) && !jmbg) {
            // toast('Morate unijeti ime i prezime studenta.');
            return;
        }
        if ((localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'Support')) {
            // for admin

            this.setState({
                firstName, lastName, index, jmbg
            }, () => this.getStudentsForAdmin());
        } else {
            // for users
            this.setState({
                firstName, lastName, index, jmbg
            }, () => this.getStudents());
        }
    }
    handleInputChange(event, { name, value }) {
        // if (name === 'orgUnit') localStorage.setItem('orgUnit', value);
        localStorage.setItem(name, value);
        this.setState({
            [name]: value
        });
    }

    showStudent() {
        this.setState({ showMessage: false });
        if ((localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'Support')) {
            this.getStudentsForAdmin();
        } else { this.getStudents(); }
    }

    getStudentsForAdmin() {
        const {
            firstName, lastName, index, orgUnit, jmbg
        } = this.state;

        if (!firstName && !lastName && !index && !jmbg) {
            toast('Morate unijeti bar jedan filter.');
            return;
        }
        if (!orgUnit && (!firstName || !lastName) && !jmbg) {
            toast('Morate unijeti ime i prezime studenta ili jmbg.');
            return;
        }
        this.setState({ loading: true });
        let docFilter = {};

        if (firstName) docFilter = { ...docFilter, firstName };
        if (lastName) docFilter = { ...docFilter, lastName };
        if (index) docFilter = { ...docFilter, index };
        if (jmbg) docFilter = { ...docFilter, jmbg };


        axios.post((this.state.orgUnit)
            ? `students/filter-students-by-organizational-unit/${this.state.orgUnit}`
            : 'students/get-all-students/', { ...docFilter })
            .then(res => {
                const filterData = res.data.map(el => ({
                    ...el,
                    key: el.id,
                    value: {
                        id: el.id,
                        el: { ...el }
                    },
                    text: el.firstName + '    ' + el.lastName + '  |  ' + el.studyProgramName,
                    studyType: el.studyTypeId ? this.state.studyTypes.find(e => e.id === el.studyTypeId).name : null,
                    studentStatus: el.studentStatusId ? this.state.studentStatuses.find(e => e.id === el.studentStatusId).name : null,
                }));
                this.setState({ filterData, loading: false, showMessage: true });
                if (!filterData.length) {
                    axios.get('students/filter-by-organizational-unit/', { params: docFilter })
                        .then(res => {
                            this.setState({ filterDataOrgUnit: res.data, loading: false, showMessage: true });
                        })
                        .catch(err => {
                            console.log('Failed to fetch students');
                        });
                }
            })
            .catch(err => {
                console.log('Failed to fetch filter results');
            });
    }

    getStudents() {
        const {
            firstName, lastName, index, jmbg
        } = this.state;

        if (!firstName && !lastName && !index && !jmbg) {
            toast('Morate unijeti bar jedan filter.');
            return;
        }
        this.setState({ loading: true });
        let docFilter = {};

        if (firstName) docFilter = { ...docFilter, firstName };
        if (lastName) docFilter = { ...docFilter, lastName };
        if (index) docFilter = { ...docFilter, index };
        if (jmbg) docFilter = { ...docFilter, jmbg };

        axios.post('students/filter-students-by-organizational-unit', { ...docFilter })
            .then(res => {
                const filterData = res.data.map(el => ({
                    ...el,
                    studyType: el.studyTypeId ? this.state.studyTypes.find(e => e.id === el.studyTypeId).name : null,
                    studentStatus: el.studentStatusId ? this.state.studentStatuses.find(e => e.id === el.studentStatusId).name : null
                }));
                this.setState({ filterData, loading: false, showMessage: true });
                if (!filterData.length) {
                    axios.get('students/filter-by-organizational-unit/', { params: docFilter })
                        .then(res => {
                            this.setState({ filterDataOrgUnit: res.data, loading: false, showMessage: true });
                        })
                        .catch(err => {
                            console.log('Failed to fetch students');
                        });
                }
            })
            .catch(err => {
                console.log('Failed to fetch filter results');
            });
    }


    render() {
        const { removeHeader, transferSemester } = this.props;
        const { filterData } = this.state;
        if (this.state.showStudentInfo === true) {
            if (transferSemester) {
                localStorage.setItem('filterData', JSON.stringify(filterData));
                return <Redirect push to={{ pathname: '/prebacivanje-semestara/semestri', state: { student: this.state.student, filterData: this.state.filterData } }} />;
            }
            return <Redirect push to={{ pathname: '/filtriranje-studenata/informacije-o-studentu', state: { student: this.state.student } }} />;
        }
        return (
            <div >
                {!removeHeader && <h1>Filtriranje studenata</h1>}
                <Segment.Group raised>
                    <Segment><Header>Svi studenti na fakultetu

                        <Header style={IconHeader} floated="right" >

                            <Button
                                size="small"
                                style={FiltersOnStyle}
                                onClick={this.resetFilters}
                                color="basic"
                                fluid
                            >
                                Očisti filtere
                            </Button>

                        </Header>

                    </Header></Segment>
                    <Segment clearing>


                        {(localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'Support') &&
                            <Form>
                                <Form.Group widths="equal">
                                    <Form.Field disabled={!this.state.orgUnits}>
                                        <label>Organizaciona jedinica</label>
                                        <Form.Dropdown
                                            clearable
                                            placeholder="Odaberite organizacionu jedinicu"
                                            value={this.state.orgUnit}
                                            onChange={this.handleInputChange}
                                            name="orgUnit"
                                            options={this.state.orgUnits}
                                            search
                                            fluid
                                            selection
                                        />
                                    </Form.Field>
                                    <Form.Field />
                                    <Form.Field />
                                </Form.Group>

                            </Form>
                        }
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field

                                    control={Input}
                                    label="Ime"
                                    placeholder="Ime"
                                    value={this.state.firstName}
                                    name="firstName"
                                    onChange={this.handleInputChange}

                                />
                                <Form.Field

                                    control={Input}
                                    label="Prezime"
                                    placeholder="Prezime"
                                    value={this.state.lastName}
                                    name="lastName"
                                    onChange={this.handleInputChange}

                                />
                                <Form.Field

                                    control={Input}
                                    label="Broj indexa"
                                    placeholder="Index"
                                    value={this.state.index}
                                    name="index"
                                    onChange={this.handleInputChange}
                                />
                                <Form.Field

                                    control={Input}
                                    label="JMBG"
                                    placeholder="JMBG"
                                    value={this.state.jmbg}
                                    name="jmbg"
                                    onChange={this.handleInputChange}
                                />

                            </Form.Group>

                            <Button floated="right" color="blue" onClick={this.showStudent}>Prikaži studenta</Button>
                        </Form>
                        <br />

                        <ToastContainer hideProgressBar />

                        {!this.state.loading ?
                            <div>
                                <br />

                                { this.state.filterData.length ? <Table celled selectable compact >
                                    <Table.Header>
                                        <Table.Row>

                                            <Table.HeaderCell width="4">Prezime <span style={{ color: '#a6a4a1', fontWeight: 'normal' }} >(djevojačko prezime)</span> i ime</Table.HeaderCell>
                                            <Table.HeaderCell width="2">Broj indexa</Table.HeaderCell>
                                            <Table.HeaderCell width="2">JMBG</Table.HeaderCell>
                                            <Table.HeaderCell>Odsjek</Table.HeaderCell>
                                            <Table.HeaderCell>Studijski program</Table.HeaderCell>
                                            {(localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'Support') && !this.state.orgUnit && <Table.HeaderCell>Organizaciona jedinica</Table.HeaderCell>}
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body> {this.state.filterData.map((el, index) =>
                                        (<Popup
                                            trigger={<Table.Row
                                                key={index}
                                                style={HeaderCursor}
                                                onClick={() => {
                                                    this.setState({ student: el, showStudentInfo: true });
                                                    localStorage.setItem('student', JSON.stringify(el));
                                                    localStorage.setItem('orgUnit', JSON.stringify(el.organizationalUnitId));
                                                }}
                                            >

                                                <Table.Cell verticalAlign="middle" width="4">
                                                    {el.lastName} {el.maidenName ? <span style={{ color: '#a6a4a1' }} >({el.maidenName})</span> : null} {el.firstName}
                                                    {el.locked === 1 ? <span style={{ float: 'right' }}> <Icon name="lock" color="blue" /></span> : null}
                                                    {el.studyProgramStudentSwitchedToId ? <span style={{ float: 'right' }}> <Icon name="check" color="blue" /></span> : null}
                                                    {el.dateOfAbandonment !== null ? <span style={{ float: 'right' }}> <Icon name="sign-out" color="red" /></span> : null}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle" width="2">
                                                    {el.index}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle" width="2">
                                                    {el.jmbg}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.departments.map(e => (<div>{e.name} <br /></div>))}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle">
                                                    <strong>{el.studyProgramBasicName}</strong>
                                                    { ' | ' + el.studyProgramName}
                                                    <span style={{ color: '#a6a4a1' }}>{el.studyProgramDescription ? ' | ' + el.studyProgramDescription : ''}</span>
                                                </Table.Cell>
                                                {(localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'Support') && !this.state.orgUnit && <Table.Cell verticalAlign="middle">
                                                    {el.organizationalUnitName}
                                                </Table.Cell>}
                                            </Table.Row>}
                                            content="Prikaz informacija o studentu"
                                            hideOnScroll
                                            position="left center"
                                        />))}
                                    </Table.Body>
                                </Table>
                                    : this.state.showMessage && 'Nema studenata.'}
                            </div>
                            : <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div> }
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/StudentOverviewFilter.js